import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminPageSectionMeta = ({
  section,
  showAlign,
  handleChangeSection,
}) => {
  const intl = useIntl();

  const handleChange = (e) => {
    const {
      name,
      value,
    } = e.target;

    handleChangeSection({
      ...section,
      [name]: value,
    });
  };

  return (
    <div className="section-meta">
      <Row form>
        <Col>
          <Label htmlFor={`section-title-${section.id}`}>
            {intl.formatMessage({ defaultMessage: 'Title' })}
          </Label>
          <Input
            id={`section-title-${section.id}`}
            name="title"
            defaultValue={section.title}
            onChange={handleChange}
          />
        </Col>
        {showAlign && (
          <Col xs="3">
            <Label htmlFor={`section-align-${section.id}`}>
              {intl.formatMessage({ defaultMessage: 'Align' })}
            </Label>
            <Input
              type="select"
              className="custom-select"
              id={`section-align-${section.id}`}
              name="align"
              defaultValue={section.align || 'left'}
              onChange={handleChange}
            >
              <option value="left">{intl.formatMessage({ defaultMessage: 'Left' })}</option>
              <option value="center">{intl.formatMessage({ defaultMessage: 'Center' })}</option>
              <option value="right">{intl.formatMessage({ defaultMessage: 'Right' })}</option>
            </Input>
          </Col>
        )}
        <Col xs="12">
          <Label htmlFor={`section-title-${section.id}`}>
            {intl.formatMessage({ defaultMessage: 'Subtitle' })}
          </Label>
          <Input
            id={`section-subtitle-${section.id}`}
            name="subtitle"
            defaultValue={section.subtitle}
            onChange={handleChange}
          />
        </Col>
      </Row>
      <hr />
    </div>
  );
};

AdminPageSectionMeta.propTypes = {
  section: PropTypes.object.isRequired,
  showAlign: PropTypes.bool,
  handleChangeSection: PropTypes.func.isRequired,
};

AdminPageSectionMeta.defaultProps = {
  showAlign: true,
};

export default AdminPageSectionMeta;
